class rakdCustomizerCart{  

  static init(){
    const $removeButtons = document.querySelectorAll('.rakdCustomizerCart__removeItem')
    
    $removeButtons.forEach($removeButton=>$removeButton.addEventListener('click', rakdCustomizerCart.removeItems))
    
  }


  static removeItem = () => {
    
  }


  static removeItems(ev) {
    
    const $button = ev.target;
    const customizationId = $button.getAttribute('data-customization-id');
    
    
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    })
    .then(cart => {
      const items = cart.items.filter(item=>item.properties.customizationId == customizationId)
      
      return items
    })
    .then(
      items => {
        
        const updates = {};
        
        items.forEach(item => updates[item.id] = 0 )
      	
        jQuery.ajax(
          {
            type: 'post',
            url: window.Shopify.routes.root + 'cart/update.js',
            data: { updates: updates },
            dataType: 'JSON',
            success: () => {
				location.reload();
          	},
         	error: (err) => {
                console.error('Error:', err);
          alert('ERROR!')
          
        }
          
          }
          
        );
      }
      
    )
    .catch((error) => {
      console.error('Error:', error);
    });
    
  }


}

rakdCustomizerCart.init()